import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import UI from 'root/ui';
import Svg_Icon from 'root/module/svg_icon';
import Form from 'root/module/form';
import View from 'view/base';
import View_Message_Editor from 'view/portal/message_editor';
import Dnd_File_Uploader from 'root/module/dnd_file_uploader';

export default View.extend({
    className: 'overlay overlay-sidebar overlay-portal',

    categories: [],
    attachment: [],

    views: {
        message_editor: {}
    },

    suggestion_cache: {},

    events: {
        'click .close'                     : 'onClose',
        'input input[name="idea_title"]'   : 'onEnterTitle',
        'click .feedback-suggestion'       : 'onOpenSuggestion',
        'click .dropdown-category li'      : 'onSelectCategory',
        'click .dropdown-category .btn'    : 'onRemoveCategory',
        'click .screenshot-attach .add'    : 'onAttachImages',
        'click .screenshot-attach .remove' : 'onRemoveImage',
        'click .submit'                    : 'onSubmit'
    },

    dom_handlers: {
        onClose: function(e) {
            this.trigger('close');
        },

        onEnterTitle: function(e) {
            var title = $(e.currentTarget).val().trim();

            if (!title) {
                this.clearSuggestion();
                return;
            }

            if (this.search_xhr) {
                this.search_xhr.abort();
            }

            if (typeof this.suggestion_cache[title] !== 'undefined') {
                this.renderSuggestion(this.suggestion_cache[title]);
                return;
            }

            clearTimeout(this.suggestion_timeout);
            this.suggestion_timeout = setTimeout(function() {
                this.search_xhr = Cache.app.request({
                    action: 'portal/suggest',
                    context: this,
                    data: {
                        title: title
                    },
                    success: function(response) {
                        this.renderSuggestion(response);
                        this.suggestion_cache[title] = response;
                    },
                    error: function() {
                        // ignore
                    }
                });
            }.bind(this), 300);
        },

        onOpenSuggestion: function(e) {
            var feedback_id = parseInt($(e.currentTarget).data('id'), 10);
            var idea_title  = this.$el.find('input[name="idea_title"]').val().trim();

            this.trigger('openSuggestion', feedback_id, idea_title);
        },

        onSelectCategory: function(e) {
            var category = $(e.currentTarget).text();

            if (this.categories.indexOf(category) === -1) {
                this.categories.push(category);
            } else {
                this.categories.splice(this.categories.indexOf(category), 1);
            }

            this.renderCategories();

            $(e.currentTarget).toggleClass('selected');
        },

        onRemoveCategory: function(e) {
            var category = $(e.currentTarget).data('val');
            var index    = this.categories.indexOf(category);

            if (index !== -1) {
                this.categories.splice(index, 1);
            }

            this.renderCategories();
        },

        onAttachImages: function(e) {
            Util.uploadImages(10, 10, (response) => {
                response.forEach((data) => {
                    if (!data.error) {
                        this.attachment = this.attachment.concat(data);
                    }
                });
                this.renderImages();
            });
        },

        onRemoveImage: function(e) {
            this.attachment.splice($(e.currentTarget).parent().index(), 1);
            this.renderImages();
        },

        onSubmit: function(e) {
            if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
                Modals.portalGuest();
                return;
            }

            var message_data = this.views.message_editor.get();
            var title        = this.$el.find('input[name="idea_title"]').val().trim();
            var description  = message_data.comment;

            if (!title) {
                this.$el.find('input[name="idea_title"]').focus();
                return;
            }

            if (!description) {
                this.views.message_editor.focus();
                this.$el.find('.region-message-editor').addClass('invalid');
                return;
            }

            this.$el.find('.region-message-editor').removeClass('invalid');

            // disable form
            this.views.message_editor.disable();
            this.$el.find('input[name="idea_title"]').prop('disabled', true);
            this.$el.find('.dropdown-category > button').prop('disabled', true);
            this.$el.find('.submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'feedback/newIdea',
                context: this,
                data: {
                    title       : title,
                    description : description,
                    categories  : this.categories,
                    screenshots : this.attachment
                },
                error: function() {
                    // enable form
                    this.views.message_editor.enable();
                    this.$el.find('input[name="idea_title"]').prop('disabled', false);
                    this.$el.find('.dropdown-category > button').prop('disabled', false);
                    this.$el.find('.submit').removeClass('loading').prop('disabled', false);

                    UI.error('Couldn\'t submit idea. Please try again later.');
                },
                success: function(response) {
                    if (Cache.portal.at(0).get('approve_portal')) {
                        this.trigger('close', {
                            new_feedback: response
                        });
                    } else {
                        this.$el.find('.portal-new-idea-success').show();
                    }
                }
            });
        },

        documentClick: function(e) {
            if ($.contains(this.$el.find('.region-suggestion').get(0), e.target)) {
                return;
            }

            if ($(e.target).hasClass('region-suggestion')) {
                return;
            }

            this.clearSuggestion();
        },
    },

    event_handlers: {
        handleFiles: function(files) {
            this.$el.find('.dnd-dropzone').hide();
            if (files.length === 0) {
                return;
            }

            for (var i = 0; i < files.length; i++) {
                if (files[i].type.indexOf('image/') === -1) {
                    continue;
                }

                Util.readFile(files[i], 10, (file_name, file_type, file_content) => {
                    if (this.attachment.length >= 3) {
                        this.$el.find('.error-msg').toggle(true);
                        return;
                    }

                    this.attachment = this.attachment.concat({name: file_name, type: file_type, content: file_content, width: 100, height: 100});
                    this.renderImages();
                });
            }
        },

        handleDragEnter: function() {
            this.$el.find('.dnd-dropzone').show();
        },

        handleDragLeave: function(event) {
            if (event.target === this.$el.find('.dnd-dropzone').get(0)) {
                this.$el.find('.dnd-dropzone').hide();
            }
        }
    },

    initialize: function(options) {
        this.embed = options.embed;
        this.idea_title = options.idea_title;

        this.views.message_editor = new View_Message_Editor({
            model         : this.model,
            embed         : this.embed,
            has_submit    : false,
            public_toggle : false,
            attachment    : false,
            show_tools    : true,
            placeholder   : Cache.portal.at(0).getTranslation('new_idea_summary_placeholder'),
            disable_dnd   : true,
            new_idea      : true,
        });

        this.on('remove', function() {
            $(document).off('click.portal_new_idea');
        });

        $(document).on('click.portal_new_idea', this.dom_handlers.documentClick.bind(this));

        this.uploader = new Dnd_File_Uploader(
            this.event_handlers.handleFiles.bind(this),
            this.event_handlers.handleDragEnter.bind(this),
            undefined,
            this.event_handlers.handleDragLeave.bind(this)
        );
    },

    focus: function() {
        this.$el.find('input[name="idea_title"]').focus();
    },

    clearSuggestion: function() {
        this.$el.find('.region-suggestion').hide().html('');
    },

    renderSuggestion: function(feedback_rows) {
        var content = ''

        feedback_rows.forEach(function(data) {
            var vote_count = data.vote_count;

            if (vote_count >= 1000) {
                vote_count = (vote_count / 1000).toFixed(1) + 'k';
            }

            var categories = '';

            if (data.category) {
                data.category.split(',').forEach(function(category_name) {
                    if (Cache.feedback_category.findWhere({name: category_name})) {
                        categories += '<a class="#">#' + Util.htmlEntities(category_name) + '</a>';
                    }
                });
            }

            content +=
            '<div class="feedback-suggestion" data-id="' + data.id + '">' +
                '<div>' +
                    '<div class="vote">' + (data.vote_count >= 1000 ? ((data.vote_count / 1000).toFixed(1) + 'k') : data.vote_count) + '</div>' +
                '</div>' +
                '<div>' +
                    '<div class="title">' + (Util.htmlEntities(data.title) || 'Untitled') + '</div>' +

                    (data.description ?
                    '<div class="desc">' + Util.htmlEntities(data.description) + '</div>' : '') +

                    (categories ?
                    '<div class="categories">' + categories + '</div>' : '') +

                    '<div class="date">' + Util.moment(data.date) + '</div>' +
                '</div>' +
            '</div>';
        });

        if (content) {
            content = '<div class="heading">Similar ideas:</div>' + content;

            this.$el.find('.region-suggestion').html(content).show();
        } else {
            this.$el.find('.region-suggestion').hide();
        }
    },

    renderCategories: function() {
        var categories_selected = '';
        var category_options    = '';

        this.categories.forEach(function(category_name) {
            categories_selected +=
            '<span class="badge-primary-invert">' + Util.htmlEntities(category_name) + '</span>';
        });

        Cache.feedback_category.each(function(model) {
            if (Cache.portal.at(0).get('categories').split(',').indexOf(model.get('name')) === -1) {
                return;
            }

            category_options += '<li' + (this.categories.indexOf(model.get('name')) === -1 ? '' : ' class="selected"') + '>' + model.escape('name') + '</li>';
        }, this);

        if (categories_selected) {
            this.$el.find('.dropdown-category > button').html(categories_selected).removeClass('placeholder');
        } else {
            this.$el.find('.dropdown-category > button').text('Select').addClass('placeholder');
        }

        this.$el.find('.dropdown-category ul').html(category_options);
    },

    renderImages: function() {
        this.$el.find('.screenshot-attach .preview > div').remove();

        this.attachment.forEach(function(image_info) {
            $('<div>')
                .css('background-image', 'url(' + image_info.content + ')')
                .html('<button class="remove" type="button"><i class="fas fa-times-circle"></i></button>')
                .appendTo(this.$el.find('.screenshot-attach .preview'));
        }.bind(this));

        this.$el.find('.screenshot-attach .add').toggle(this.attachment.length < 3);
        this.$el.find('.error-msg').toggle(this.attachment.length > 3);
        this.$el.find('.submit').prop('disabled', this.attachment.length > 3);
    },

    render: function() {
        var thankyou_message = Cache.portal.at(0).getTranslation('new_idea_thankyou').split(/(?:\r\n|\r|\n)/);
        var thankyou_heading = thankyou_message[0];
        var thankyou_body    = thankyou_message.slice(1).join('<br>');

        var content = '';

        content +=
        '<div class="portal-feedback-details portal-feedback-details-small">' +
            '<button type="button" class="close btn-close">' +
            (this.embed === 'widget' ?
            '<i class="fa-regular fa-chevron-left"></i>' : '<i class="fa-regular fa-xmark"></i>') +
            '</button>' +
            '<div class="portal-new-idea">' +
                '<h2>' + (Cache.portal.at(0).getTranslation('new_idea_heading', true)) + '</h2>' +
                '<div class="idea-help">' + (Cache.portal.at(0).getTranslation('new_idea_desc', true)) + '</div>' +

                '<div class="idea-form">' +
                    '<div class="category-select">' +
                        '<span class="category-label">Category:</span>' +
                        '<div class="button-dropdown button-dropdown-left dropdown-category">' +
                            '<button type="button" class="dropdown-select dropdown-select-medium dropdown-select-multiple"></button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-select"></ul>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +

                    '<div class="idea-title">' +
                        '<input type="text" name="idea_title" placeholder="' + (Cache.portal.at(0).getTranslation('new_idea_title_placeholder')) + '" maxlength="200">' +
                        '<div class="region-suggestion dropdown-box"></div>' +
                    '</div>' +

                    '<div class="region-message-editor"></div>' +

                '</div>' +

                '<div class="screenshot-attach">' +
                    '<div class="preview"></div>' +
                    '<div class="add">' +
                        '<div>' +
                            '<span><i class="far fa-image"></i></span>' +
                            '<span><i class="far fa-plus"></i></span>' +
                        '</div>' +
                    '</div>' +
                '</div>' +

                '<div class="error-msg">You may only attach a maximum of 3 images</div>' +

                (this.embed === 'widget' ?
                '<div class="divider-24"></div>' :
                '<div class="divider-32"></div>') +

                '<button type="submit" class="submit primary ' + (this.embed === 'widget' ? 'small-medium fluid font-weight-semibold' : 'medium') + '">' + Cache.portal.at(0).getTranslation('submit_idea_button') + '</button>' +
            '</div>' +
            '<div class="portal-new-idea-success">' +
                '<div class="flex-c">' +
                    '<div>' +
                        Svg_Icon.checkmark +
                        '<h3>' + thankyou_heading + '</h3>' +
                        '<div class="line-height-150">' + thankyou_body + '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="dnd-dropzone" data-size="large" data-theme="light" style="display:none"></div>' +
        '</div>';

        this.$el.html(content);

        this.renderCategories();

        this.views.message_editor.render().$el.appendTo(this.$el.find('.region-message-editor'));

        if (this.idea_title) {
            Form.setData(this.$el, {
                idea_title: this.idea_title
            });
        }

        this.uploader.setupDropArea(this.$el.find('.portal-feedback-details').get(0));

        return this;
    }
});